import store from "@/store";

// Upgraded to meet the platform's async execution standard
export default async (to, from, next) => {
    // Normalize paths by removing trailing slashes (e.g., "/validation/" becomes "/validation")
    const normalizedPath = to.path.replace(/\/$/, "");

    // Safety: Never block or run destructive logout resets on the validation callback view
    if (normalizedPath === "/validation") {
        return next();
    }

    if (to.meta.requiresAuth && (!store.state.auth.isAuthenticated || store.state.auth.isTokenExpired)) {
        if (normalizedPath && normalizedPath !== "") {
            store.commit("auth/setRedirectLink", to.path);
            localStorage.setItem('currentUrl', to.path);
        }

        // Await the state teardown completely before letting the route resolve
        await store.dispatch("auth/logout");
        return next(false);
    }
    
    return next();
}